import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/mapto";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as ErrorHandler from "../common/errorHandler";
import * as DTOS from "../FeralScan.dtos";
import { serviceApi } from "../services/user.service";
import { getReferenceDataRequest } from "../actions/dashboard.actions";
import * as Configuration from '../components/Framework/configuration/index'

import {
    LOGIN, LOGIN_WITH_TOKEN, LOGOUT,
    ILoginActions, loginSuccess, logoutSuccess, ILoginAction, ILoginWithTokenAction, ILogoutAction, loginFail
} from "../actions/login.actions";
import { push } from "connected-react-router";
import { sendActivateAccount, getCurrentUserRequest } from "../actions/user.actions";

export const login = action$ =>
    action$
        .ofType(LOGIN)
        .mergeMap((action: ILoginAction) =>
            serviceApi
                .login(action.username, action.password, action.rememberMe)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(loginSuccess(response)),
                        Observable.of(getReferenceDataRequest()),
                        Observable.of(getCurrentUserRequest()),
                        Observable.of(push(Configuration.AppConfig.defaultLoginSuccessRoute))
                    )
                })
                .catch((error) => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error),
                        Observable.of(loginFail(error))
                    )
                })
                //.catch((error: DTOS.AuthenticateResponse) => ErrorHandler.FireErrorActions(error))
        );

export const loginWithToken = action$ =>
    action$
        .ofType(LOGIN_WITH_TOKEN)
        .mergeMap((action: ILoginWithTokenAction) =>
            serviceApi
                .loginWithToken(action.username, action.password)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(loginSuccess(response)),
                        Observable.of(getReferenceDataRequest()),
                        Observable.of(getCurrentUserRequest())
                    )
                })
                .catch((error) => {
                    return concat$(
                        ErrorHandler.FireErrorActions(error),
                        Observable.of(loginFail(error))
                    )
                })
                //.catch((error: DTOS.AuthenticateResponse) => ErrorHandler.FireErrorActions(error))
        );

export const logout = action$ =>
    action$
        .ofType(LOGOUT)
        .mergeMap((action: ILogoutAction) =>
            serviceApi
                .logout()
                .mergeMap(response => {
                    return concat$(
                        Observable.of(logoutSuccess(response)),
                        Observable.of(getReferenceDataRequest()),
                        Observable.of(push('/'))
                    )
                })
                .catch((error: DTOS.AuthenticateResponse) => ErrorHandler.FireErrorActions(error))
        );